import {SignableDocumentType} from "@/constants/SignatureConstants";
import FileMetaDTO from "@/dto/files/FileMetaDTO";

export default class CreatePrefilledCompanyDocumentPayload {
    type: SignableDocumentType | null = null;
    companyId: number | null = null;
    file: FileMetaDTO | null = null;
}